export default __webpack_public_path__ + "669c0584db43631c264d18e731a113a9.png";